"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../../internal/utils");
function isDisabledRecord(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
option, grid, row) {
    if (grid.disabled) {
        return true;
    }
    return getBooleanOptionOfRecord(option, grid, row);
}
exports.isDisabledRecord = isDisabledRecord;
function isReadOnlyRecord(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
option, grid, row) {
    if (grid.readOnly) {
        return true;
    }
    return getBooleanOptionOfRecord(option, grid, row);
}
exports.isReadOnlyRecord = isReadOnlyRecord;
function getBooleanOptionOfRecord(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
option, grid, row) {
    if (typeof option === "function") {
        const record = grid.getRowRecord(row);
        if (utils_1.isPromise(record)) {
            return true;
        }
        return !!option(record);
    }
    return !!option;
}
